export default{
  "banner": {
    "tittle": "Build Your AI Universe",
    "sub_tittle": "Defining the Next Trillion-Dollar AI Economy"
  },
  "validator": {
    "tittle": "Open Call for Validators",
    "sub_tittle": "Remaining Slots",
    "remain_text": "Seats Left",
    "price_text": "Price",
    "wallet_text": "Base Chain Wallet Address",
    "description_text": "Please transfer to the above address"
  },
  "about": {
    "section_tittle": "About",
    "tittle1": "Defining the Next-Gen AI Economy",
    "tittle1_info_text": "AIVerse pioneers the decentralized AI Agent value network, integrating AI creation, trading, and autonomous economics to democratize ownership of AI-powered production assets.",
    "tittle2": "Why Us?",
    "sub_tittle1": "Open Ecosystem",
    "info_text1": "Disrupt tech oligopolies with no-code AI tools and tokenized revenue sharing",
    "sub_tittle2": "Scarce Infrastructure",
    "info_text2": "50+ Global Prime Validators Sharing Ecosystem Rewards",
    "sub_tittle3": "Cutting-Edge Tech",
    "info_text3": "Proprietary AI Engine 3.0 delivers 200% faster inference with 1M+ TPS",
    "tittle3": "Credibility",
    "tittle3_info_text": "Led by ex-Google DeepMind architect and former Microsoft Azure principal engineer, with audited smart contracts by SlowMist, backed by Binance Labs and top-tier VCs.",
    "user1_desc1": "Ex-Senior Researcher at Google DeepMind",
    "user1_desc2": "Contributor to Transformer Architecture Design",
    "user1_desc3": "Published 20+ Top-Tier AI Papers",
    "user2_desc1": "Ex-Principal Architect of Microsoft Azure AI",
    "user2_desc2": "Led AI Products Serving 10M+ Users",
    "user2_desc3": "12 Years Enterprise AI Experience",
    "circle1_text": "App Store Attribute",
    "circle2_text": "NYSE Attribute"
  },
  "architecture": {
    "section_tittle": "Product Architecture",
    "tittle": "AIVerse Four-Asset System",
    "sub_tittle1": "Prime Validators",
    "sub_tittle1_text1": "Chief Validators",
    "sub_tittle1_text2": "Eco-infrastructure Nodes",
    "sub_tittle1_text3": "Governance Rights + Revenue Sharing",
    "sub_tittle2": "AI Agent Tokens",
    "sub_tittle2_text1": "Application Tokens",
    "sub_tittle2_text2": "Independent Token for AI Projects",
    "sub_tittle2_text3": "Value-linked with AION",
    "sub_tittle3": "AION",
    "sub_tittle3_text1": "Platform Token",
    "sub_tittle3_text2": "Core Value Carrier",
    "sub_tittle3_text3": "Payment, Staking, Governance",
    "sub_tittle4": "AIP",
    "sub_tittle4_text1": "AIVerse Points",
    "sub_tittle4_text2": "Contribution Metrics",
    "sub_tittle4_text3": "Determines Tiered Benefits"
  },
  "roadmap": {
    "section_tittle": "Roadmap",
    "parse_4_tittle": "Parse 4",
    "parse_4_text1": "1,000+ AI Agent Ecosystem",
    "parse_4_text2": "Top 3 Global AI Platform",
    "parse_4_text3": "1B+ User Ecosystem",
    "parse_4_text4": "Market Cap Target",
    "parse_4_text5": "$10B",
    "parse_2_tittle": "Parse 2",
    "parse_2_text1": "AION Listed on Top 5 CEX",
    "parse_2_text2": "100 AI Agents Launched",
    "parse_2_text3": "200K MAU",
    "parse_2_text4": "Market Cap Target",
    "parse_2_text5": "$1.5B",
    "parse_3_tittle": "Parse 3",
    "parse_3_text1": "Multi-Chain Deployment",
    "parse_3_text2": "500 AI Agents Launched",
    "parse_3_text3": "1M MAU",
    "parse_3_text4": "Market Cap Target",
    "parse_3_text5": "$3B",
    "parse_1_tittle": "Parse 1",
    "parse_1_text1": "$5M Seed Funding",
    "parse_1_text2": "Prime Validator Presale",
    "parse_1_text3": "50K Seed Users",
    "parse_1_text4": "Market Cap Target",
    "parse_1_text5": "$500M"
  },
  "footer": {
    "sub_tittle": "Build Your AI Universe",
    "main_tittle": "Define the Future of AI Economy With Us"
  },
  "contact": {
    "tittle": "Contact Us"
  },
  "common": {
	"copySuccess":"Copy Success!"
  }
}